module.exports = "https://www.gc-pro.gnp.com.mx/99be43e0aabe8ac7f0124254424f3538.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/phonelink_24px.svg
// module id = 1856
// module chunks = 0